<template>
  <div class="app-options-select-deactivate" v-if="options">
    <slot name="txtHeader"><h2>Optionen auswählen</h2></slot>
    <p><slot name="txtDesc">Wählen Sie</slot></p>
    <div class="options-wrapper">
      <div class="option-headline">
        <b-row class="data-line thead">
          <b-col class="data-cell first">
            <slot name="txtBookedOptionsHeader">Gebuchte Tarifoptionen</slot>
          </b-col>
          <b-col class="data-cell duration">
            <slot name="txtDuration">Laufzeit</slot>
          </b-col>
          <b-col class="data-cell third">
            <slot name="txtDeactivate">deaktivieren</slot>
          </b-col>
        </b-row>
      </div>
      <label :data-disabled="isDisabled(option)" :for="'option-'+ option.id "
             v-for="option in deactivatableOptions" :key="option.id" class="option-box row"
             :id="option.id">
        <b-col class="option">
          <div class="option-main-box">
            <div class="image">
              <img v-if="option.icon" :src="option.icon">
            </div>
            <div class="checkbox-label">
              <span v-html="option.name"></span>
              <span v-if="option.extraHtml" v-html="option.extraHtml"></span>
              <div class="option-info">
                <p v-if="!viewDeactivate && option.desc" v-html="option.desc">
                </p>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="info">
          <div class="info-box">
          <span class="option-info" v-if="!viewDeactivate && option.price !== 0  && option.duration.amount">
            {{ centsToEuros(option.price) }} / {{option.duration.amount}} {{ durationUnit(option.duration.unit) }}
          </span>
          <span v-else-if="CDLOrTERStatusInfo(option)">
            <span class="tariff-status" :class="option.statusKey">{{ option.status.heading }}</span>
            <br>
            <span class="tariff-message">
              {{option.status.message.replace('%date%',formatDate(option.endOfRuntime))}}
            </span>
          </span>
          <span v-else-if="viewDeactivate && option.status !== undefined">
            <span class="tariff-status" :class="option.statusKey">{{ option.status.heading }}</span>
            <br>
            <span class="tariff-message">{{ option.status.message }}</span>
          </span>
          <span v-else>
            <div class="txt-for-free"><slot name="txtForFree">kostenlos</slot></div>
            <div class="txt-no-duration"><slot name="txtNoDuration">Gültig bis: unbefristet</slot></div>
          </span>
            <div v-if="option.info"
                 v-b-tooltip.hover.bottom="{customClass: 'wide-tooltip'}" :title="option.info"
                 class="info-bubble">
              <img class="hover-toggle" :src="option.infoBubbleImage">
            </div>
          </div>
        </b-col>
        <b-col class="input-radio">
          <input type="radio"
                 :id="'option-' + option.id"
                 :value="option"
                 v-model="mutableSelectedOptions"
                 :name="'option-' + option.id"
                 class="select-box"
                 @change="selectOption(option)">
        </b-col>
      </label>
      <slot name="txtBeforeFormattedBalance" v-if="isBalanceSet"><div class="txt-before-formatted-balance" >Ihr Guthaben beträgt: {{balance}}</div></slot>
      <Stepper
        :show-prev="true"
        @prev="prev"
        @next="next"
        :disabledNext="disabledNext"
        :loading-next="loading"
      >
        <template #btnNext><slot name="btnNext">deaktivieren</slot></template>
      </Stepper>
    </div>
  </div>
</template>

<script>
import durationUnit from '../../../../../mixins/durationUnit'
import Stepper from '../../../../generic/Stepper.vue'
import { stepName as successStep } from './ServiceOptions/Success.vue'
import { stepName as viewStep } from './View.vue'
import { stepName as summaryStepName } from './Summary.vue'
import processSteps from '@/mixins/processSteps'

export const stepName = 'selectDeactivate'

export default {
  name: 'OptionsSelectDeactivate',
  components: { Stepper },
  computed: {
    isBalanceSet () {
      return this.balance !== null
    },
    disabledNext: function () {
      return this.mutableSelectedOptions.length === 0
    },
    deactivatableOptions: function () {
      return this.options.filter(option => option.cancelable)
    }
  },
  data () {
    return {
      mutableSelectedOptions: this.selectedOptions
    }
  },
  props: {
    viewDeactivate: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array
    },
    selectedOptions: {
      type: Array,
      default: () => []
    },
    status: {
      type: Array
    },
    balance: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    CDLOrTERStatusInfo: function (option) {
      return this.viewDeactivate && (option.statusKey === 'CDL' || option.statusKey === 'TER') && option.endOfRuntime !== undefined
    },
    formatDate (date) {
      if (date) {
        return this.$config.calendar.formatter.dateFormatter.format(new Date(date))
      }
    },
    isDisabled (option) {
      this.$emit('is-disabled', option)
    },
    selectOption (option) {
      this.$emit('update:mutableSelectedOptions', this.mutableSelectedOptions)
      this.$emit('select-option', option)
    },
    centsToEuros (value) {
      return this.$config.calendar.formatter.currencyFormatter.format(parseInt(value) / 100)
    },
    next () {
      this.$emit('update-options', { step: summaryStepName, options: this.mutableSelectedOptions })
    },
    prev () {
      this.$emit('update-step', this.previousStep)
    }
  },
  mixins: [
    durationUnit,
    processSteps(stepName, viewStep, summaryStepName, successStep)
  ]
}
</script>
